module.exports = "<div ng-if=\"vm.show\" class=\"environment-banner\">\n  {{ vm.environment }}\n</div>\n"